import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { getPortalVersion, PortalVersion } from 'src/app/portal-config';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.css']
})
export class LogoutPageComponent implements OnInit {

  constructor(
    private router: Router,
    public auth: AuthService) { }

  ngOnInit() {
    sessionStorage.removeItem('loggedIn');
    let logoutUrl = getPortalVersion() == PortalVersion.BBP ? environment.redirectUrlBroker : environment.redirectUrlGL;
    this.auth.logout({ logoutParams: { returnTo: logoutUrl } });
  }

}
